/**
 * 파트 정의 목록/상세 설정 (screen_part_definition CRUD)
 * screen-part의 list/detail 컴포넌트와 호환되는 config 형태.
 * (ScreenPartConfig 타입과 구조 호환, 순환 의존성 회피를 위해 타입 import 없음)
 */
export const SCREEN_PART_DEFINITION_CONFIG = {
  title: 'brandFn.menu.partDefinition',
  apiBasePath: 'api/screen-part/definition',
  isDefinition: true,
  viewType: 'table',
  searchFields: [
    { name: 'id', type: 'text', label: 'REPO.TABLE.partDefinition.id' },
    {
      name: 'partCategory',
      type: 'select',
      label: 'REPO.TABLE.partDefinition.category',
      options: [
        { value: 'PACKAGE', label: 'PACKAGE' },
        { value: 'HOTEL', label: 'HOTEL' },
        { value: 'RESTAURANT', label: 'RESTAURANT' },
        { value: 'TOUR', label: 'TOUR' },
        { value: 'COMMON', label: 'COMMON' },
        { value: 'BOOKING', label: 'BOOKING' },
      ],
    },
    {
      name: 'label',
      type: 'text',
      label: 'REPO.TABLE.partDefinition.label',
    },
    {
      name: 'partType',
      type: 'text',
      label: 'REPO.TABLE.partDefinition.partType',
    },
    {
      name: 'isSystemFl',
      type: 'select',
      label: 'REPO.TABLE.partDefinition.isSystemFl',
      options: [
        { value: 'true', label: 'System' },
        { value: 'false', label: 'Custom' },
      ],
    },
  ],
  columns: [
    {
      key: 'id',
      name: 'REPO.TABLE.partDefinition.id',
      type: 'number',
      width: '80px',
      class: 'text-center',
      sortable: true,
    },
    {
      key: 'partCategory',
      name: 'REPO.TABLE.partDefinition.category',
      type: 'text',
      width: '120px',
      sortable: true,
    },
    {
      key: 'label',
      name: 'REPO.TABLE.partDefinition.label',
      type: 'text',
      sortable: true,
      filterable: true,
    },
    {
      key: 'partType',
      name: 'REPO.TABLE.partDefinition.partType',
      type: 'text',
      width: '200px',
      sortable: true,
    },
    {
      key: 'description',
      name: 'REPO.TABLE.partDefinition.description',
      type: 'text',
      sortable: false,
      filterable: false,
    },
    {
      key: 'icon',
      name: 'REPO.TABLE.partDefinition.icon',
      type: 'text',
      width: '100px',
      class: 'text-center',
    },
    {
      key: 'isSystemFl',
      name: 'REPO.TABLE.partDefinition.isSystemFl',
      type: 'boolean',
      width: '100px',
      class: 'text-center',
    },
    {
      key: 'displayOrder',
      name: 'REPO.TABLE.partDefinition.displayOrder',
      type: 'number',
      width: '100px',
      class: 'text-center',
      sortable: true,
    },
  ],
  defaultPageSize: 5,
  defaultSort: 'displayOrder,asc',
  routePath: 'paywith-master/homepage-part-definition',
};
